// Time-of-day greetings, US federal holiday awareness, and contextual openers
// used by Jerry's first message.

// Returns the nth weekday of a month, e.g. nthWeekday(2026, 11, 4, 4) = 4th Thursday of November 2026
function nthWeekday(year, month0, weekday, n) {
    const first = new Date(year, month0, 1);
    const offset = (weekday - first.getDay() + 7) % 7;
    return new Date(year, month0, 1 + offset + (n - 1) * 7);
}

function lastWeekday(year, month0, weekday) {
    const last = new Date(year, month0 + 1, 0);
    const offset = (last.getDay() - weekday + 7) % 7;
    return new Date(year, month0, last.getDate() - offset);
}

const FIXED_HOLIDAYS = {
    "0-1":   "Happy New Year",
    "1-14":  "Happy Valentine's Day",
    "6-4":   "Happy Independence Day",
    "9-31":  "Happy Halloween",
    "10-11": "Honoring our Veterans today",
    "11-24": "Merry Christmas Eve",
    "11-25": "Merry Christmas",
    "11-31": "Happy New Year's Eve",
};

// [monthIndex, (year) => Date, label]
const COMPUTED_HOLIDAYS = [
    [0,  (y) => nthWeekday(y, 0, 1, 3),  "Honoring Dr. King today"],
    [4,  (y) => lastWeekday(y, 4, 1),    "Remembering on Memorial Day"],
    [8,  (y) => nthWeekday(y, 8, 1, 1),  "Happy Labor Day"],
    [10, (y) => nthWeekday(y, 10, 4, 4), "Happy Thanksgiving"],
];

export function holidayLabel(d) {
    const y = d.getFullYear();
    const m = d.getMonth();
    const day = d.getDate();
    const fixed = FIXED_HOLIDAYS[`${m}-${day}`];
    if (fixed) return fixed;
    for (const [hm, fn, label] of COMPUTED_HOLIDAYS) {
        if (m === hm && fn(y).getDate() === day) return label;
    }
    return null;
}

// Named constants for time-of-day thresholds (24-hour clock).
const MORNING_START = 5;
const NOON = 12;
const EVENING_START = 17;
const NIGHT_START = 22;

export function timeOfDayGreeting() {
    const h = new Date().getHours();
    if (h >= MORNING_START && h < NOON)        return "Good morning";
    if (h >= NOON          && h < EVENING_START) return "Good afternoon";
    if (h >= EVENING_START && h < NIGHT_START) return "Good evening";
    return "Hi there";
}

export function contextualOpener() {
    const now = new Date();
    const holiday = holidayLabel(now);
    if (holiday) return `${holiday}! ${timeOfDayGreeting().replace("Good ", "I hope you're having a good ")}`;
    if (now.getDay() === 5) return `Happy Friday! ${timeOfDayGreeting()}`;
    if (now.getDay() === 1) return `Hope you're having a good start to the week — ${timeOfDayGreeting().toLowerCase()}`;
    return timeOfDayGreeting();
}

// Monotonically increasing id helper so message keys are stable across renders.
let _msgId = 0;
export const newMsg = (role, content) => ({
    id: `m-${Date.now()}-${++_msgId}`,
    role,
    content,
});

export function buildGreeting(name) {
    const opener = contextualOpener();
    const youPart = name ? `, ${name}` : "";
    return {
        id: `g-${Date.now()}`,
        role: "assistant",
        content: `${opener}${youPart}! I'm Jerry — the virtual receptionist for Crossroads to Change Residential Treatment Center. I'd love to help you find what you're looking for. Ask me about our program, the referral process, or anything else you'd like to know.`,
    };
}
